module.exports = __webpack_public_path__ + "static/media/bkg09n.3bd32388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg09n.jpg
// module id = 472
// module chunks = 0